import { deleteCookie, getCookie, getCookies, hasCookie, setCookie, OptionsType } from 'cookies-next';

export const setCookieData = (name: string, value: unknown, options?: OptionsType) => {
  if (!name || !value) return;
  if (typeof value === 'object') {
    value = JSON.stringify(value);
  }
  setCookie(name, value, {
    secure: process.env.NEXT_PUBLIC_ZENV !== 'loc',
    ...options
  });
};

export const getCookieData = (name: string, options?: OptionsType) => {
  const data = getCookie(name, options);
  try {
    return data && JSON.parse(<string>data);
    // eslint-disable-next-line unused-imports/no-unused-vars
  } catch (_) {
    return data;
  }
};

export const getAllCookieData = (options?: OptionsType) => {
  return getCookies(options);
};

export const deleteCookieData = (name: string, options?: OptionsType) => {
  const deleteCookieOptions = Object.assign({ secure: process.env.NEXT_PUBLIC_ZENV !== 'loc' }, options, { expires: undefined });
  if (hasCookie(name, deleteCookieOptions)) {
    deleteCookie(name, deleteCookieOptions);
  }
};

export const hasCookieData = (name: string, options?: OptionsType) => {
  return hasCookie(name, options);
};
